import { AnyAction } from "@reduxjs/toolkit";
import { AnexoSolicitacao } from "model/solicitacao/AnexoSolicitacao";
import { SolicitacaoResumida } from "model/solicitacao/SolicitacaoResumida";
import { OperacaoFormularioCRUD } from "service/restricao/OperacaoFormulario/OperacaoFormulario";
import { EstadoRequisicao } from "store/types";
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils";


// ------------------
// Actions
// ------------------
export type SolicitacaoCorrenteActionTypes = AnyAction;


// ------------------
// States
// ------------------
export enum SolicitacaoCorrenteAcao {
  /**
   * Criar uma nova solicitação
   */
  Criar = 'criar',
  /**
   * Solicitar e visualizar uma solicitação
   */
  Visualizar = 'visualizar',
  /**
   * Atualizar a solicitação
   * 
   * A atualização pode ocorrer inclusive quando a operação do formuário é Visualizar.
   * Isto ocorre quando atualiza a situação por botão
   */
  Atualizar = 'atualizar',
}

export interface SolicitacaoCorrenteState {
  /**
   * Operação referente ao formulário
   */
  operacao: OperacaoFormularioCRUD;
  estado: EstadoRequisicao;
  acao: SolicitacaoCorrenteAcao;

  erros?: ResponseError;

  solicitacao: SolicitacaoResumida;
  anexos: {
    elementos: AnexoSolicitacao[];
    estado: EstadoRequisicao;
  }
}